import { Label, LabelWrapper } from "./MarketplaceLabel.styled";

interface IMarketplaceLabelProps {
  quantity: number;
  hasSale: boolean;
}

function Sale() {
  return <Label color="bluePink">Sale</Label>;
}

function OutOfStock() {
  return <Label color="pinkViolet">Out of stock</Label>;
}

function LeftFewItems() {
  return <Label color="yellowPink">Few items left</Label>;
}

export function MarketplaceLabel(props: IMarketplaceLabelProps) {
  const { quantity, hasSale } = props;

  return (
    <LabelWrapper>
      {hasSale && <Sale />}
      {!quantity && <OutOfStock />}
      {quantity < 4 && <LeftFewItems />}
    </LabelWrapper>
  );
}
